import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { esES as coreEsES } from "@mui/material/locale";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ErrorBoundary } from "react-error-boundary";

import Configuration from "./generic/components/configuration/Configuration";
import ErrorDisplay from "./generic/components/error-display/ErrorDisplay";
import GenericLandingPage from "./generic/pages/landing/GenericLandingPage";
import EmbeddingRootApp from "./applications/embedding/EmbeddingRootApp";
import EmbeddingNativeRootApp from "./applications/embedding_native/EmbeddingNativeRootApp";
import LoginPage from "./generic/pages/login-page/LoginPage";
import { mstrPath } from "./utils/mstrBase";
import "./mstr-icons.css";
function RootApp(props) {
  const { application } = useParams();
  const history = useHistory();
  const theme = createTheme(coreEsES, {
    typography: {
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
      fontSize: 14,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <ErrorBoundary
        FallbackComponent={ErrorDisplay}
        onError={(error, errorInfo) => {
          history.push(mstrPath(`error?type=${error.message ? error.message : "GENERIC_ERROR"}`));
        }}
      >
        <Configuration application={application}>
          {/* <EnvironmentValidation application={application}> */}
          <div className="RootApp">{getApplication(application)}</div>
          {/* </EnvironmentValidation> */}
        </Configuration>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

function getApplication(application) {
  switch (application) {
    case "login":
      return <LoginPage />;
    case "embedding":
      return <EmbeddingRootApp />;
    case "embedding_native":
      return <EmbeddingNativeRootApp />;
    default:
      return <GenericLandingPage />;
  }
}

export default RootApp;
